import React, { Component  } from 'react';

import {Howl} from 'howler';

import { connect } from "react-redux";
import { helperFunctions } from "../lib/helperFunctions";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class PlaySound extends Component {

    constructor(props) {
        super(props);
        this.endPlay=this.endPlay.bind(this);
        helperFunctions.eventEmitter.addListener('play_sound', (e) => this.playSound(e));
        helperFunctions.eventEmitter.addListener('play_dispatch', (e) => this.playDispatch(e));
    }
    endPlay(){
        const props=this.props;
        setTimeout(function () {
            props.dispatch({
                type: "SET_SOUND",
                data: {
                    playing : false,
                    type : ""
                }
            });

        },500);

    }

    playDispatch= (e) =>{
        const props=this.props;
            console.log("bb");
        props.dispatch({
            type: "SET_SOUND",
            data: {
                playing: true,
                type: "queuedVisitor"
            }
        });
    }
    playSound = (e) => {
        if (e.type === "incomingChat") {
            this.playSoundFile('incoming_chat');
        }
        if (e.type === "queuedVisitor") {
            this.playSoundFile('queued_visitor');
        }

    }

    playSoundFile = (file) => {
        var sound = new Howl({
            src: [
                 "/Public/sound/"+file+".mp3"
            ],
            format: ['mp3'],
            autoplay: true,
            onend: this.endPlay()
        });
        sound.play();
    }

    render() {
        return null;
    }
}

export default connect()(PlaySound)

